import { Component, OnInit, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { LoggerService } from 'src/app/shared/services/logger/logger.service';
@Component({
  selector: 'app-authcallback',
  templateUrl: './authcallback.component.html',
  styleUrls: ['./authcallback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthcallbackComponent implements OnInit {
  err:any;
  constructor(private okta: OktaAuthService,  private loggerService:LoggerService,
    ) {
    
   
   }
  ngOnInit() {
   this.okta.handleAuthentication ().then (res => {
      console.log ("ansd auth is ..", res);
       
    }).catch (err => {
      this.err = err;
      console.log ("where is err", err);
      
    });
  }
}

